"use strict";

import "../../scss/pages/map5g.scss";
import TomSelect from "tom-select/dist/js/tom-select.complete.min";
import axios from "axios";
import GlobalError from "../helpers/globalError";
import ModalDownloadMobileApp from "../components/modal-download-mobile-app";

document.addEventListener("DOMContentLoaded", function () {
	const containerInitMessage = document.querySelector('.container-init-message');
	const progressBar = containerInitMessage.querySelector('.progress-init-bar');
	const message = containerInitMessage.querySelector('.init-content');
	let progress = 0;
	const main = document.querySelector('.container-page');
	
	if (((sessionStorage.getItem('modalDownloadAppShown') !== 'true') && main) && ((main.dataset.deviceType === 'Mobile Device') || (main.dataset.deviceType === 'Mobile Phone'))) {
		import('../components/modal')
			.then((module) => {
				
				const params = {
					deviceType: main.dataset.deviceType
				}
				const modalModule = new module.Modal();
				modalModule.openModal('modal-download-mobile-app modal-auth modal-slide-up', 'modalDownloadMobileApp', './modal/modal-download-mobile-app', params, ModalDownloadMobileApp.handleOnOpen, ModalDownloadMobileApp.activeSession);
			})
	}
	
	setTimeout(() => {
		if (progressBar) {
			progressBar.parentNode.classList.remove('d-none');
		}
		message.textContent = message.dataset.transMessage;
		containerInitMessage.progress = 50;
		progressBar.style.width = `${ progress }%`;
	}, 2000);
	
	setTimeout(() => {
		
		const mapTypeActions = {
			'country': false,
			'isp': false,
			'mapType': false,
			'fullscreen': true,
			'search': true
		}
		
		const languageSelected = document.querySelector('#dropdownlanguageMenu');
		const config = {
			onUploadProgress: (progressEvent) => {
				const {loaded, total} = progressEvent;
				progress = Math.round((loaded * 100) / total);
				progressBar.style.width = `${ progress }%`;
			}
		}
		
		axios.post(`/${ languageSelected.dataset.languageSelected }/map/load-map-component`, {
				mapType: '5G',
				mapVersion: 0,
				typeActionsMap: mapTypeActions,
				geoId: 0,
			}, config)
			.then(((response) => {
				const containerModuleMap = document.querySelector('.container-module-map');
				if (progress === 100) {
					containerModuleMap.classList.add('anim-module');
					containerInitMessage.classList.add('anim-container-init');
					containerModuleMap.innerHTML = response.data;
				}
				
				import('../components/map')
					.then((module) => {
						const mapModule = new module.Map();
						mapModule.initializeMap('5G').then(() => {
							new TomSelect("#selectTileMap", {
								labelField: 'value',
								valueField: 'value',
								allowEmptyOption: true,
								maxOptions: null,
								create: false,
								options: [
									{value: "arcGis", text: "ArcGIS"},
									{value: "openStreetMap", text: "OpenStreetMap"},
									{value: "arcGisHybrid", text: "ArcGIS Hybrid"},
								],
								controlInput: null,
								items: ['arcGis'],
								hideSelected: true,
								render: {
									item: function (item, escape) {
										return '<div data-tile-name="' + escape(item.value) + '"  aria-label="' + escape(item.value) + '">' +
											'<span class="name">' + escape(item.text) + '</span>' +
											'</div>';
									},
									option: function (item, escape) {
										return '<div data-tile-name="' + escape(item.value) + '"  aria-label="' + escape(item.value) + '">' +
											'<span class="name">' + escape(item.text) + '</span>' +
											'</div>';
									}
								},
								onChange: function (event) {
									mapModule.toggleTileMap(event, '5G');
								}
							});
							
							new TomSelect("#inputMapSearch", {
								labelField: 'placeId',
								valueField: 'placeId',
								persist: false,
								createOnBlur: false,
								create: false,
								maxItems: 1,
								maxOptions: null,
								searchField: ['name'],
								hideSelected: true,
								load: function (query, callback) {
									mapModule.getResultSearchList(query, callback, '5G');
								},
								render: {
									item: function (item, escape) {
										return '<div data-id="' + escape(item.placeId) + '" data-type="' + escape(item.iconName) + '" data-bounding-box="' + escape(item.boundingCoordinates) + '">' +
											'<span class="name">' + escape(item.name) + '</span>' +
											'</div>';
									},
									option: function (item, escape) {
										return '<div data-id="' + escape(item.placeId) + '" data-type="' + escape(item.iconName) + '" data-bounding-box="' + escape(item.boundingCoordinates) + '">' +
											'<i class="' + escape(item.iconName) + '"></i>' +
											'<span class="name">' + escape(item.name) + '</span>' +
											'</div>';
									}
								},
								onChange: function () {
									mapModule.refreshMap('5G');
									mapModule.refreshSearchOptions();
								},
								onDropdownOpen: function () {
									mapModule.refreshSearchOptions();
								}
							});
							
							const buttonFullScreenList = document.querySelectorAll('.btn-full-screen');
							buttonFullScreenList.forEach((buttonFullScreen) => {
								buttonFullScreen.addEventListener('click', () => {
									mapModule.toggleFullscreen();
								});
							})
							
							const mapCanvas = document.querySelector('#map');
							mapCanvas.addEventListener('wheel', (event) => {
								event.stopPropagation();
								if (event.ctrlKey) {
									event.preventDefault();
									mapModule.mapRef.scrollWheelZoom.enable();
								} else {
									mapModule.mapRef.scrollWheelZoom.disable();
								}
							})
							const containerMapElement = document.querySelector('.container-select-map');
							containerMapElement.addEventListener("fullscreenchange", () => {
								if (!document.fullscreenElement) {
									mapModule.displayFullScreenElements(containerMapElement, false);
								}
							});
						});
					})
				
			}))
			.catch((error) => {
				if (error.response && error.response.data.errors) {
					GlobalError.openErrorModal(error.response.data.errors.message, 'globalErrorMap');
				}
			});
	}, 2500);
	
});